import React from 'react';
import { motion } from 'framer-motion';
import Button from './ui/Button';

const Hero = () => {
  return (
    <div className="relative h-screen min-h-[640px]">
      <div className="absolute inset-0">
        <picture>
          <source
            media="(max-width: 767px)"
            srcSet="/static/images/heroImg-640.webp"
            type="image/webp"
          />
          <source
            srcSet="/static/images/heroImg.webp"
            type="image/webp"
          />
          <source
            media="(max-width: 767px)"
            srcSet="/static/images/heroImg-640.jpg"
          />
          <img
            src={'/static/images/heroImg.jpg'}
            alt="Massage therapist providing a spa treatment"
            className="w-full h-full object-cover"
            width="1024"
            height="1024"
            fetchPriority="high"
            decoding="async"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/90 via-primary-dark/40 to-primary-dark/20"></div>
      </div>

      <div className="relative z-10 flex flex-col items-start md:items-center justify-center h-full text-left md:text-center text-white px-6 md:px-4">
        <motion.span
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="uppercase tracking-[0.35em] text-xs md:text-sm text-accent-light font-body mb-4 md:mb-6"
        >
          Serenoly &middot; Massage &amp; Wellness
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.15 }}
          className="text-4xl md:text-6xl lg:text-7xl font-heading font-medium leading-tight mb-6 max-w-4xl"
        >
          <span className="italic text-accent-light">Awaken</span> Your Best Self<br className="hidden md:block" /> with Every Touch
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.35 }}
          className="text-base md:text-lg text-secondary/90 max-w-xl mb-10 font-body font-light leading-relaxed"
        >
          Verified therapists, brought to your home, hotel, or a partner spa
          &mdash; on your schedule. Every session tailored to leave you
          feeling restored, balanced, and truly renewed.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.55 }}
          className="flex flex-col sm:flex-row items-start md:items-center gap-4"
        >
          <Button
            to="/book-massage"
            size="large"
            className="bg-accent text-primary-dark font-semibold px-8 py-3 rounded-full text-sm md:text-base tracking-wide hover:bg-secondary hover:text-primary-dark transition-colors shadow-lg"
          >
            BOOK A MASSAGE
          </Button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="mt-14 flex items-center gap-6 md:gap-10 text-secondary/80 text-xs md:text-sm font-body tracking-wide"
        >
          <span>Verified Therapists</span>
          <span className="w-1 h-1 rounded-full bg-accent-light" />
          <span>Escrow-Protected Payment</span>
          <span className="w-1 h-1 rounded-full bg-accent-light hidden md:inline-block" />
          <span className="hidden md:inline">Rated &amp; Reviewed</span>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
